import { useState, useCallback } from "react";
import { useAiAgentChat } from "@/hooks/ai-agent/useAiAgentChat";
import { useUserback } from "@/contexts/UserbackContext";
import { AiAgentChatButton } from "./AiAgentChatButton";
import { AiAgentChatPanel } from "./AiAgentChatPanel";

export const AiAgentChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { messages, isLoading, sendQuestion, clearChat, submitFeedback, usageInfo, quotaExceeded } =
    useAiAgentChat();
  const { userback } = useUserback();
  const hasUserback = !!userback;

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      {!isOpen && <AiAgentChatButton onClick={handleOpen} hasUserback={hasUserback} />}
      {isOpen && (
        <AiAgentChatPanel
          messages={messages}
          isLoading={isLoading}
          onSend={sendQuestion}
          onClose={handleClose}
          onClear={clearChat}
          onSubmitFeedback={submitFeedback}
          usageInfo={usageInfo}
          quotaExceeded={quotaExceeded}
          hasUserback={hasUserback}
        />
      )}
    </>
  );
};
